import { useState } from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {useDispatch} from "react-redux";
import {PublicVerifyIdentity} from "../../../../reduxToolkit/CompanyEmployees/CompanyEmployeesApi";
import {
    BUILDING_REGISTRATION_STATUS_MODEL_CARD,
    resolveVerifiedIdentity
} from "../Model/Model";
/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 * @returns {Object} An object containing state variables and handler functions:
 * - buildingId / buildingApartmentId / userId: Parameters of the link the resident opened.
 *   The link of the whole building carries the building, the one copied for a
 *   resident carries their apartment and their user instead, and from there on
 *   the apartment travels in the place of the building.
 * - visitorStatus: Card painted for the registration invitation.
 * - loading: Blocks the button while the identity is read.
 * - handleStartRegistration: Reads whether the identity of the user of the link
 *   is still pending and continues into the identity validation, or into the
 *   screen of the registration already finished, skipping the identify you step.
 */
const BuildingRegistrationExternalApp = () => {
    const { buildingId, buildingApartmentId, userId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [visitorStatus] = useState({ ...BUILDING_REGISTRATION_STATUS_MODEL_CARD.PROCEED_WITH_REGISTRATION }); // visitor_status_id
    const [loading, setLoading] = useState(false);

    /**
     * Starts the registration of the resident the link was copied for. The user
     * of the link is enough to read the status of their identity, so the identify
     * you form is skipped and the flow goes straight into the identity validation.
     */
    const handleStartRegistration = () => {
        if (!userId || loading) {
            return;
        }

        setLoading(true);

        dispatch(PublicVerifyIdentity(userId)).then(({payload}) => {
            const resolved = resolveVerifiedIdentity({payload, buildingApartmentId, userId, dispatch, navigate});

            // The button is only released when the resident stays on this screen,
            // the validation already navigated away otherwise
            if (!resolved) {
                setLoading(false);
            }
        }).catch(() => {
            setLoading(false);
        });
    };

    return {
        buildingId,
        userId,
        visitorStatus,

        loading,
        handleStartRegistration,
    }
}

export default BuildingRegistrationExternalApp
